/**
 * App routes used by the auth flow. These are app routes, not IdP
 * configuration — under the old redirect flow they lived in msalConfig.ts,
 * which is why deleting that file touched three others.
 */
export const SIGNED_OUT_PATH = '/signed-out';
export const FORGOT_PASSWORD_PATH = '/forgot-password';
export const SIGN_IN_PATH = '/sign-in';

/**
 * The MFA routes. The first two sit inside AuthGuard but outside SessionGuard:
 * /me refuses the user until they have enrolled, so nesting them inside
 * SessionGuard is the same redirect loop router.tsx warns about for
 * /access-not-provisioned.
 */
export const MFA_ENROLL_PATH = '/security/enroll';
export const MFA_REPLACE_AUTHENTICATOR_PATH = '/security/replace-authenticator';
export const SECURITY_SETTINGS_PATH = '/security';

/**
 * Why a flow sent the user back to sign-in. Each one ends the session on
 * purpose, so the sign-in screen says so rather than looking like a failure.
 */
export const SIGN_IN_REASONS = ['second-factors-changed', 'second-factor-enrolled'] as const;
export type SignInReason = (typeof SIGN_IN_REASONS)[number];

export function signInPathFor(reason: SignInReason): string {
  return `${SIGN_IN_PATH}?reason=${reason}`;
}

export function parseSignInReason(search: string): SignInReason | null {
  const reason = new URLSearchParams(search).get('reason');
  return SIGN_IN_REASONS.find((r) => r === reason) ?? null;
}
